import { ConfirmAction } from '../actions/confirmActions'
import { SET_LOADING_CONFIRM_SUCCESS } from '../types/confirmActionsTypes'

export interface confirmaActionState {
  isLoadingConfirm: boolean
}

const initialState: confirmaActionState = {
  isLoadingConfirm: false
}

export const confirmActionReducer = (
  state: confirmaActionState = initialState,
  action: ConfirmAction
): confirmaActionState => {
  if (action.type === SET_LOADING_CONFIRM_SUCCESS) {
    return {
      ...state,
      isLoadingConfirm: action.isLoadingConfirm
    }
  }
  return state
}
